export enum ProductionLineField {
    ID = 'id',
    LINE_NUMBER = 'lineNumber',
    STORAGE = 'storage',
    STORAGE_NAME = 'storageName',
}
